module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.missionSlotGroup.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotGroup.description),
      expression: "missionSlotGroup.description"
    }],
    staticClass: "word-wrap"
  }, [_vm._v(_vm._s(_vm.missionSlotGroup.description))]), _vm._v(" "), _c('mission-slot-template-slotlist-group-slots-table', {
    attrs: {
      "missionSlotGroup": _vm.missionSlotGroup
    }
  }), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.index > 0) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.moveMissionSlotTemplateSlotGroup(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.move.up')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.index < (_vm.missionSlotGroupCount - 1)) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.moveMissionSlotTemplateSlotGroup(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.move.down')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotCreateModal",
      modifiers: {
        "missionSlotTemplateSlotCreateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.setMissionSlotTemplateSlotGroupDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slot')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotGroupEditModal",
      modifiers: {
        "missionSlotTemplateSlotGroupEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.setMissionSlotTemplateSlotGroupDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.slotGroup')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.duplicateMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slotGroup')) + "\n    ")]), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slotGroup.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n      ")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01f5c1ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroup.vue
// module id = 466
// module chunks = 0